import P2Section1 from "./P2Section1";
import P2Section2 from "./P2Section2";
import P2Section3 from "./P2Section3";
import P2Section4 from "./P2Section4";


const Page2 = () => {
    return (

        <div className="Page2">
            <P2Section1/>
            <P2Section2/>
            <P2Section3/>
            <P2Section4/>
        </div>
        
      );
}
 
export default Page2;